import axios from "axios";
import { BASE_URL } from "./endpoints";
import { getToken } from "../utils/authHelper";
import { persistor, store } from "../app/store";
import { getGlobalNavigate } from "../utils/helpers";
import { logout } from "../features/auth/authSlice";
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});
export const axiosFormInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

const getIpAddress = async () => {
  try {
    const response = await axios.get("https://api.ipify.org?format=json");
    return response.data.ip;
  } catch (error) {
    console.error(error);
    return null;
  }
};

axiosInstance.interceptors.request.use(
  async (config) => {
    const token = getToken();
    // const ip_address = await getIpAddress();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // if (config.method === "post") {
    //   config.data = {
    //     ...config.data,
    //     ip_address,
    //   };
    // }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosFormInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
